import BasicLightbox from "../../BasicLightbox";
import ScrollUtils from "../../util/ScrollUtils";
import KEY_HANDLERS, {isEsc} from '../../keyHandlers/index'
import $ from "jquery";

export default class PermissionsDescriptionLightBox extends BasicLightbox {
    constructor({
        additionalClass = '',
        onClickDialogContent = () => {},
    } = {}) {
        super()
        this.additionalClass = additionalClass
        this.exist_invalid_fields_message_key = "";
        this.close_tab_confirmation_message_key = "";
        this.moireDivId = "permissionsMoireDiv";

        this.params = {
            onClickDialogContent,
        }
    }

    show() {
        // this is place where we can place additional class, used in UserATProfileSection.js
        this.getPopupEl().addClass(this.additionalClass)
        super.show()
        if (_.isUndefined(this.verticalScroll))
            this.verticalScroll = ScrollUtils.addVerticalScroll($("#permissionsDescriptionContainer"));
    }

    hide() {
        super.hide()
        this.getPopupEl().removeClass(this.additionalClass)
    }

    init($elementToCallPopup) {
        super.init("permissionsInfoLightBox", "closePermissionsDescriptionLightBoxBtn");
        const self = this;
        this.setCancelCallback(() => self.hide());
        $elementToCallPopup.on("click", () => self.show());
        this.getPopupEl().click((e) => this.params.onClickDialogContent(e))
        $(this.getMoireDiv()).click((e) => this.params.onClickDialogContent(e))
    }

    restoreOnKeyDownHandler() {
        if (this.removeHandler) this.removeHandler()
    }

    setupKeyDownHandler() {
        this.removeHandler = KEY_HANDLERS.onKeyDown((code) => {
            if (isEsc(code)) {
                this.hide()
                return true
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/PermissionsDescriptionLightBox.js